export const graphicDesigns = {
    slug: 'graphic-designs',
    no: '06',
    type: 'external',
    title: 'Graphic Designs',
    category: 'Graphic Design',
    sourceUrl: 'https://himanshutanty.com/portfolio/graphic-designs/',
    cover: '/api/files/466a2c8b-b647-4132-9133-4ca3afd78117',
    external: {
        label: 'View Project on Behance',
        href: 'https://www.behance.net/gallery/70116581/LOGO-DESIGN',
    },
    next: {
        slug: 'portal-for-site-contractors',
        title: 'Portal For Site Contractors',
    },
};
